const base = "/api";
const url = base.endsWith("/") ? base : `${base}/`;

export const API_URL = url;
export default url;
